import { useMemo } from 'react';

import {
	AnswerReveal,
	PointsRow,
	StandardPatternBody,
} from '@quizzach/components';
import { IQuestion } from '@quizzach/interfaces';
import { analyzeStandardQuestion, patternAnswerHtml } from '@quizzach/utils';
import { QuestionText, QuestionContainer } from '@quizzach/play-styles';

interface IStandardQuestionProps {
	color: string;
	currentQuestionNumber: number;
	currentQuestion: IQuestion;
	totalQuestions?: number;
}

interface IStandardQuestionAnswerProps {
	questionContainerColor: string;
	answerContainerColor: string;
	currentQuestionNumber: number;
	currentQuestion: IQuestion;
	totalQuestions?: number;
}

export const StandardQuestionDesktop = (props: IStandardQuestionProps) => {
	const { color, currentQuestion } = props;

	const analysis = useMemo(
		() => analyzeStandardQuestion(currentQuestion),
		[currentQuestion]
	);

	return (
		<>
			{analysis.pattern || analysis.note || analysis.kicker ? (
				<StandardPatternBody analysis={analysis} color={color} />
			) : (
				<QuestionContainer color={color}>
					<QuestionText>
						<div
							dangerouslySetInnerHTML={{
								__html: currentQuestion.standard_question?.question_hr || '',
							}}
						/>
					</QuestionText>
				</QuestionContainer>
			)}
			<PointsRow
				points={currentQuestion.points}
				explanation={currentQuestion.points_explanation}
			/>
		</>
	);
};

export const StandardQuestionAnswerDesktop = (
	props: IStandardQuestionAnswerProps
) => {
	const { questionContainerColor, currentQuestionNumber, currentQuestion } =
		props;

	const analysis = useMemo(
		() => analyzeStandardQuestion(currentQuestion),
		[currentQuestion]
	);

	return (
		<>
			{analysis.pattern || analysis.note || analysis.kicker ? (
				<StandardPatternBody
					analysis={analysis}
					color={questionContainerColor}
					dim
				/>
			) : (
				<QuestionContainer color={questionContainerColor}>
					<QuestionText $small style={{ margin: '20px 0px 0px' }}>
						<div
							dangerouslySetInnerHTML={{
								__html: currentQuestion.standard_question?.question_hr || '',
							}}
						/>
					</QuestionText>
				</QuestionContainer>
			)}
			<AnswerReveal
				revealKey={currentQuestionNumber}
				answerHtml={patternAnswerHtml(
					analysis.pattern,
					currentQuestion.standard_question?.answer_hr || ''
				)}
				explanation={currentQuestion.standard_question?.explanation_hr}
			/>
			<PointsRow
				points={currentQuestion.points}
				explanation={currentQuestion.points_explanation}
			/>
		</>
	);
};
